import { useEffect } from "react";

export function useSelfPosition(searchParams) {
  useEffect(() => {
    const x = parseInt(searchParams.get("sx"), 10);
    const y = parseInt(searchParams.get("sy"), 10);
    const w = parseInt(searchParams.get("sw"), 10);
    const h = parseInt(searchParams.get("sh"), 10);
    if ([x, y, w, h].some(Number.isNaN)) return;
    const timers = [100, 500, 1200, 2200, 3500].map(delay =>
      setTimeout(() => {
        try {
          window.resizeTo(w, h);
          window.moveTo(x, y);
        } catch {}
      }, delay)
    );
    return () => timers.forEach(clearTimeout);
  }, [searchParams]);
}
